// import { useQuery } from "@tanstack/react-query";
// import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import style from "../../styles/grid.module.css";
import { GetProfesionales } from "../../actions/profesionales";
import { GotoLogin } from "../../actions/renovarLog";

function getToday() {
   const d = new Date();
   return d.toISOString().slice(0, 10);
}
function getFirstDayOfMonth() {
   const d = new Date();
   d.setDate(1);
   return d.toISOString().slice(0, 10);
}

const Reporte = () => {
   const [reportdata, SetReportdata] = useState([]);
   const [verDatos, SetVerDatos] = useState(false);
   const [input, setInput] = useState({
      fdesde: getFirstDayOfMonth(),
      fhasta: getToday(),
      tipo: "2",
   });

   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });  


   const profesionales = GetProfesionales();
   console.log("profesionales: ", profesionales);

   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "sqlraw/reporte";
   var totales = [];
   var totalesPagos = [];

   const { mutate } = useMutation({
      mutationFn: () =>
         fetch(`${url}/${input.fdesde}|${input.fhasta}|${input.tipo}`, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (info) => {
         var ddata = [];
         var ant = 0;
         var esnuevo = false;
         console.log("RAW: ", info);

         for (let i = 0; i < info.length; i++) {
            if (parseInt(ant) !== parseInt(info[i].id_primary)) {
               if (parseInt(ant) !== 0 ) ddata.push(newData); // Grabo Informacion anterior
               esnuevo = true;
               var newData = {
                  id: info[i].id_primary,
                  fecha: info[i].fecha,
                  cliente: info[i].cliente,
                  profesional: info[i].profesional,
                  descripcion: info[i].descripcion,
                  total: info[i].total,
                  ganancia: info[i].ganancia,
                  costo: info[i].costo,
                  neto: info[i].neto,
                  netoprod: info[i].netoprod,
                  netoinsumo: info[i].netoinsumo,
                  formaPago: info[i].formaPago,
               };

            } else {
               esnuevo = false;
            }
            for (let z = 0; z < profesionales.length; z++) {
               var precio = 0;
               // console.log('let z', info[i].id_primary, profesionales[z].username,info[i].comision);
               if (profesionales[z].username === info[i].comision) {
                  // console.log("igual", profesionales[z].username);
                  precio = info[i].ganancia;
                  newData = { ...newData, [profesionales[z].username]: precio };
               }
               if (precio === 0 && esnuevo) {
                  newData = { ...newData, [profesionales[z].username]: precio };
               }
               // console.log('info[i].comision: ', info[i].comision);
               console.log('newData: ', newData);
            }
            ant = info[i].id_primary;
            // if (parseInt(info[i].servicioIdPrimary) === 99) {
            //    console.log('Es giftcard: ', info[i].cliente);
            //    ant = 0
            // }
         }
         // Grabo el ultimo
         ddata.push(newData);
         console.log("ddata fin: ", ddata);

         SetReportdata([].concat(ddata));
      },
      onError: (error) => {
         console.log("error: ", error);
         alert("Error");
      },
   });

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
      console.log("input: ", input);
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("handleSubmit: ", input);
      SetVerDatos(true);
      mutate(input);
   };

   if (profesionales?.message === "Token inválido") {
      return <GotoLogin />;
   }
   
   // console.log("datos: ", datos);
   console.log("reportdata ", reportdata);
   return (
      <>
         <div>
            <form
               onSubmit={(e) => handleSubmit(e)}
               // className="form-style-Prod"
            >
               <div>
                  <h2>Reportes Facturacion</h2>
               </div>
               <br />
               <div className={style.fecha_group}>
                  <span className={style.titledate}>Fecha desde: </span>
                  <input
                     className={style.inputdate}
                     type="date"
                     placeholder="Descripcion Producto"
                     name="fdesde"
                     value={input.fdesde}
                     onChange={handleChange}
                     required
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className={style.titledate}>Fecha hasta: </span>
                  <input
                     className={style.inputdate}
                     type="date"
                     placeholder="Descripcion Producto"
                     name="fhasta"
                     value={input.fhasta}
                     onChange={handleChange}
                     required
                  />
                  <select
                     name="tipo"
                     id="tipo"
                     onChange={handleChange}
                     value={input.tipo}
                     className={style.titledate}
                  >
                     <option value="0">Completo</option>
                     <option value="1">Piercing</option>
                     <option value="2">Tattoo</option>
                  </select>
                  &nbsp;&nbsp;&nbsp;
                  <button className={style.inputBtnNew} type="submit">
                     Procesar
                  </button>
               </div>
            </form>
            {verDatos && (
               <div style={{ borderRadius: "5px", paddingTop: "10px" }}>
                  <table className={style.gridTable}>
                     <thead>
                        <tr>
                           <th>Fecha</th>
                           <th className={style.style_titulos}>Servicio</th>
                           <th className={style.style_titulos}>Cliente</th>
                           <th className={style.style_titulos}>Profesional</th>
                           <th>Total</th>
                           <th className={style.style_titulos}>
                              Reposicion Prod.
                           </th>
                           <th className={style.style_titulos}>
                              Reposicion Ins.
                           </th>
                           <th className={style.style_titulos}>Ganancia</th>
                           {profesionales &&
                              profesionales?.map((prof, indx) => {
                                 return (
                                    <th
                                       key={indx}
                                       // className={style.style_titulos}
                                    >
                                       {prof.username}
                                    </th>
                                 );
                              })}
                        </tr>
                     </thead>
                     <tbody>
                        {reportdata?.length > 0 &&
                        reportdata[0] !== undefined ? (
                           reportdata?.map((prod, indx) => {
                              var encontre = -1;
                              var encotreformaPago = -1;

                              for (let xx = 0; xx < totalesPagos.length; xx++) {
                                 if (
                                    totalesPagos[xx].nombre === prod.formaPago
                                 ) {
                                    totalesPagos[xx].cant += parseFloat(
                                       prod.total -
                                          prod.netoprod -
                                          prod.netoinsumo,
                                    );
                                    encotreformaPago = xx;
                                 }
                              }
                              if (encotreformaPago === -1) {
                                 totalesPagos.push({
                                    nombre: prod.formaPago,
                                    cant: parseFloat(
                                       prod.total -
                                          prod.netoprod -
                                          prod.netoinsumo,
                                    ),
                                 });
                              }

                              for (let xx = 0; xx < totales.length; xx++) {
                                 if (totales[xx].nombre === "Neto Productos") {
                                    totales[xx].cant += parseFloat(
                                       prod.netoprod,
                                    );
                                    encontre = xx;
                                 }
                                 if (totales[xx].nombre === "Neto Insumos") {
                                    totales[xx].cant += parseFloat(
                                       prod.netoinsumo,
                                    );
                                    encontre = xx;
                                 }
                                 if (totales[xx].nombre === "Ganancias") {
                                    totales[xx].cant += parseFloat(
                                       prod.total -
                                          prod.netoprod -
                                          prod.netoinsumo,
                                    );
                                    encontre = xx;
                                 }
                                 if (totales[xx].nombre === "Total") {
                                    totales[xx].cant += parseFloat(prod.total );
                                 }

                                 // console.log(
                                 //    "Sumo",
                                 //    xx,
                                 //    totales[xx].nombre,
                                 //    totales[xx].cant,
                                 // );
                              }
                              if (encontre === -1) {
                                 totales.push({
                                    orden: 2,
                                    nombre: "Ganancias",
                                    cant: parseFloat(
                                       prod.total -
                                          prod.netoprod -
                                          prod.netoinsumo,
                                    ),
                                 });
                                 totales.push({
                                    orden: 3,
                                    nombre: "Neto Insumos",
                                    cant: parseFloat(prod.netoinsumo),
                                 });
                                 totales.push({
                                    orden: 4,
                                    nombre: "Neto Productos",
                                    cant: parseFloat(prod.netoprod),
                                 });
                                 totales.push({
                                    orden: 1,
                                    nombre: "Total",
                                    cant: parseFloat(prod.total),
                                 });
                                 
                              }
                              return (
                                 <tr key={indx}>
                                    <td className={style.style_td}>
                                       {prod.fecha}&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td className={style.style_titulos}>
                                       {prod.descripcion}&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td className={style.style_titulos}>
                                       {prod.cliente}&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td className={style.style_titulos}>
                                       {prod.profesional}&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td className={style.style_total}>
                                       $ {numberFormat.format(parseFloat(prod.total).toFixed(2))}
                                       &nbsp;
                                    </td>
                                    <td className={style.solopcnumeros}>
                                       $ {numberFormat.format(parseFloat(prod.netoprod).toFixed(2))}
                                       &nbsp;
                                    </td>
                                    <td className={style.solopcnumeros}>
                                       ${" "}
                                       {numberFormat.format(parseFloat(prod.netoinsumo).toFixed(2))}
                                       &nbsp;
                                    </td>
                                    <td className={style.style_precio}>
                                       ${" "}
                                       {numberFormat.format(parseFloat(
                                          prod.total -
                                             prod.netoprod -
                                             prod.netoinsumo,
                                       ).toFixed(2))}
                                       &nbsp;&nbsp;
                                    </td>
                                    {profesionales &&
                                       profesionales?.map((prof, indx) => {
                                          var importe = parseFloat(
                                             prod[prof.username],
                                          );
                                          // console.log("importe: ", importe);
                                          // console.log(
                                          //    "prof.username: ",
                                          //    prof.username
                                          // );
                                          var encontre = -1;
                                          for (
                                             let xx = 0;
                                             xx < totales.length;
                                             xx++
                                          ) {
                                             if (
                                                totales[xx].nombre ===
                                                prof.username
                                             ) {
                                                totales[xx].cant +=
                                                   parseFloat(importe);
                                                encontre = xx;
                                             }
                                          }
                                          if (encontre === -1) {
                                             totales.push({
                                                orden: 5,
                                                nombre: prof.username,
                                                cant: importe,
                                             });
                                          }
                                          return (
                                             <td
                                                key={indx}
                                                className={style.style_total}
                                             >
                                                ${" "}
                                                {numberFormat.format(parseFloat(
                                                   prod[prof.username],
                                                ).toFixed(2))}
                                                &nbsp;&nbsp;&nbsp;
                                             </td>
                                          );
                                       })}
                                 </tr>
                              );
                           })
                        ) : (
                           // Show "No data" message when no data exists
                           <tr>
                              <td
                                 colSpan={8 + (profesionales?.length || 0)}
                                 style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    fontStyle: "italic",
                                    color: "#666",
                                 }}
                              >
                                 No hay datos para mostrar. Seleccione fechas y
                                 presione Procesar.
                              </td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </div>
            )}
            <br />

            {verDatos && reportdata?.length > 0 && totales?.length > 0 && (
               <div className={style.smallheader}>
                  <div className={style.smallheader}>
                     <table className={style.gridTable}>
                        <thead>
                           <tr>
                              <th colSpan={2} className={style.resumen_titulos}>
                                 Totales{" "}
                              </th>
                           </tr>
                           <tr>
                              <th className={style.resumen_des}>Descripcion</th>
                              <th className={style.resumen_tot}>Total</th>
                           </tr>
                        </thead>
                        <tbody>
                           {totales &&
                              totales?.sort((a, b) => a.orden - b.orden).map((prof, indx) => {
                                 // console.log("totales: ", totales);
                                 return (
                                    <tr key={indx}>
                                       {/* <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
                                       <td className={style.resumen_des}>
                                          {prof.nombre}
                                       </td>
                                       <td className={style.style_total}>
                                          $ {numberFormat.format(parseFloat(prof.cant).toFixed(2))}
                                       </td>
                                       {/* <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
                                    </tr>
                                 );
                              })}
                        </tbody>
                     </table>
                  </div>
                  <div className={style.smallheader}>
                     <table className={style.gridTable}>
                        <thead>
                           <tr>
                              <th colSpan={2} className={style.resumen_titulos}>
                                 Totales por Forma de Pago
                              </th>
                           </tr>
                           <tr>
                              {/* <th>&nbsp;</th> */}
                              <th className={style.resumen_des}>Descripcion</th>
                              <th className={style.resumen_tot}>Total</th>
                              {/* <th>&nbsp;</th> */}
                           </tr>
                        </thead>
                        <tbody>
                           {totalesPagos &&
                              totalesPagos?.map((prof, indx) => {
                                 // console.log("totalesPagos: ", totalesPagos);
                                 return (
                                    <tr key={indx}>
                                       {/* <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
                                       <td className={style.resumen_des}>
                                          {prof.nombre}
                                       </td>
                                       <td className={style.style_total}>
                                          $ {numberFormat.format(parseFloat(prof.cant).toFixed(2))}
                                       </td>
                                       {/* <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td> */}
                                    </tr>
                                 );
                              })}
                        </tbody>
                     </table>
                  </div>
               </div>
            )}
         </div>
      </>
   );
};

export default Reporte;
